import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from 'src/services/auth.service';
import { EcitationUserService } from 'src/services/ecitation-user.service';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    standalone: false
})
export class FooterComponent {
  accessibilityLink = environment.accessibilityLink;
  constructor(private authService: AuthService,
     private router: Router,
     private ecitationUserService:EcitationUserService) { }


  redirectHomePage() {
    if (this.authService.getUserRole()) {
      let role = this.authService.getUserRole();
      console.log(role)
      if (role === 'ROLE_ADMIN') {
        sessionStorage.setItem('menuType', role)
        this.router.navigate(['secure/ecitationMuniStatus']);
        this.ecitationUserService.reloadComponent1()
      } else if (role === 'ROLE_NON_ADMIN') {
        sessionStorage.setItem('menuType', role)
        this.router.navigate(['secure/ecitationSearch']);
        this.ecitationUserService.reloadComponent1()
      }
    } else {
      this.router.navigate(['/']);
      this.ecitationUserService.reloadComponent1()
    }
  }


}
